import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ChillerSelectionModel } from "src/app/hubadmin/shared/models/visibility";
import { AdminDataProvider } from "src/app/hubadmin/shared/providers/master-provider/admin-data.provider";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";

@Component({
  selector: "app-chiller-selection",
  templateUrl: "./chiller-selection.component.html",
  styleUrls: ["./chiller-selection.component.scss"],
})
export class ChillerSelectionComponent implements OnInit {
  addOrEditState: string;
  formGroup: FormGroup;
  modalRef: BsModalRef;
  pageNumber: any = 1;
  getPaginationCount: any;
  submitted: boolean = false;
  chillerSelection: ChillerSelectionModel[];
  @Input() model: ChillerSelectionModel = new ChillerSelectionModel();
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public exportExcelService: ExportExcelService,
    public adminDataProvider: AdminDataProvider,
    private toast: ToastClientService,
    private modalServiceNgx: BsModalService,
    public alertService: AlertService
  ) {
    this.formGroup = this.fb.group({
      selection_value: ["", Validators.required],
      is_competitive_cooler: ["", Validators.required]
    });
  }

  ngOnInit() {
    this.getChillerSelection();
  }

  /************************************/
  // convenience getter for easy access to form fields
  get f() {
    return this.formGroup.controls;
  }
  /*********************************** */

  getChillerSelection() {
    this.apiService
      .getHeaders(
        this.apiConfig.getChillerSelection + "?page=" + this.pageNumber
      )
      .subscribe(
        (res: any) => {
          this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
          this.chillerSelection = res.body.data as ChillerSelectionModel[];
          if (this.chillerSelection.length > 0) {
            this.chillerSelection.forEach((item) => {
              if (item.status == 1) {
                item.statusString = "Active";
              } else {
                item.statusString = "Inactive";
              }

              if (item.is_competitive_cooler == 1) {
                item.competitiveString = "Non ABI Cooler";
              } else {
                item.competitiveString = "ABI Cooler";
              }
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  paginationClick(pageNumber) {
    this.pageNumber = pageNumber;
    this.getChillerSelection();
  }

  addChillerSelection(template) {
    this.addOrEditState = "add";
    this.showStateModal(template);
    this.model = new ChillerSelectionModel();
  }

  editState(template, item) {
    this.addOrEditState = "edit";
    this.model = item;
    this.showStateModal(template);
  }

  showStateModal(template) {
    this.modalService.open(template, {
      centered: true,
      backdrop: "static",
    });
  }

  confirm(): void {
    this.modalRef.hide();
  }

  decline(): void {
    this.submitted = false;
    this.modalService.dismissAll();
    this.formGroup.reset();
    this.model = new ChillerSelectionModel();
  }

  onSubmit() {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    let apiUrl;
    if (this.addOrEditState == "add") {
      apiUrl = this.apiConfig.chillerSelectionCreate;
      this.apiService.post(apiUrl, this.model).subscribe(
        (res: any) => {
          console.log("successfully Added", res);
          this.chillerSelection.push(this.model);
          this.alertService.success(res.body.data.message);
          this.decline();
        },
        (err) => {
          console.log("err", err);
        }
      );
    } else if (this.addOrEditState == "edit") {
      apiUrl = this.apiConfig.chillerSelectionUpdate + "?id=" + this.model.id;
      this.apiService.put(apiUrl, this.model).subscribe(
        (res: any) => {
          console.log("successfully Updated", res);
          this.getChillerSelection();
          this.alertService.success(res.data.message);
          this.clearSuccess();
          this.decline();
        },
        (err) => {
          console.log("err", err);
        }
      );
    }
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }
}
